import { render, staticRenderFns } from "./DelayDiscount.vue?vue&type=template&id=9d8175c4&"
import script from "./DelayDiscount.vue?vue&type=script&lang=js&"
export * from "./DelayDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports